export default "__VITE_ASSET__p_1TM9fy__"